// extracted by mini-css-extract-plugin
export var cardIcon = "_46-4";
export var checkboxCard = "_46-0";
export var checkboxCardSelected = "_46-1";
export var disabled = "_46-2";
export var outerBorder = "_46-3";
export var spacerMedium = "_46-7";
export var spacerSmall = "_46-6";
export var spacerXsmall = "_46-5";